/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChatLogData
 */
export interface ChatLogData {
    /**
     * 
     * @type {string}
     * @memberof ChatLogData
     */
    action: string;
    /**
     * 
     * @type {object}
     * @memberof ChatLogData
     */
    data: object;
    /**
     * 
     * @type {Date}
     * @memberof ChatLogData
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the ChatLogData interface.
 */
export function instanceOfChatLogData(value: object): value is ChatLogData {
    if (!('action' in value) || value['action'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function ChatLogDataFromJSON(json: any): ChatLogData {
    return ChatLogDataFromJSONTyped(json, false);
}

export function ChatLogDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatLogData {
    if (json == null) {
        return json;
    }
    return {
        
        'action': json['action'],
        'data': json['data'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function ChatLogDataToJSON(json: any): ChatLogData {
    return ChatLogDataToJSONTyped(json, false);
}

export function ChatLogDataToJSONTyped(value?: ChatLogData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'action': value['action'],
        'data': value['data'],
        'createdAt': ((value['createdAt']).toISOString()),
    };
}

